import {selector} from './selector';
import * as events from "./events";
import {verififyRegistrationPlate} from "./events";

const PageRegisterTagFormMonriMK = (function ($) {

    function checkTerms() {
        $(selector.btn.submit).prop('disabled', !$(selector.checkTerms).is(':checked'));
        $(document).on('change', selector.form.customerType, events.toggleCustomerType);
        // setTimeout(function () {
        //     $(selector.form.customerTypeChecked).trigger('change');
        // }, 500);
    }

    function initEvents() {

    }

    function initialize() {
        initEvents();
        setInterval(checkTerms, 500);
    }

    return {
        init: initialize
    }
})(jQuery);

export {PageRegisterTagFormMonriMK};